/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutStatusComment
 */
export interface CarveOutStatusComment {
    /**
     * 
     */
    comment?: string;
    /**
     * Absent when the status was changed automatically.
     */
    comment_by_name?: string;
}

/**
 * Check if a given object implements the CarveOutStatusComment interface.
 */
export function instanceOfCarveOutStatusComment(value: object): value is CarveOutStatusComment {
    return true;
}

export function CarveOutStatusCommentFromJSON(json: any): CarveOutStatusComment {
    return CarveOutStatusCommentFromJSONTyped(json, false);
}

export function CarveOutStatusCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutStatusComment {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'comment_by_name': json['comment_by_name'] == null ? undefined : json['comment_by_name'],
    };
}

export function CarveOutStatusCommentToJSON(json: any): CarveOutStatusComment {
    return CarveOutStatusCommentToJSONTyped(json, false);
}

export function CarveOutStatusCommentToJSONTyped(value?: CarveOutStatusComment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
        'comment_by_name': value['comment_by_name'],
    };
}

